module.exports = __webpack_public_path__ + "img/table.1ca5b234.webp";